module.exports = __webpack_public_path__ + "img/ic_publicity5.a3a12de9.jpeg";